import React from "react";
import { Box, Modal, Typography, Button, Stack } from "@mui/material";

type ConfirmationModalProps = {
  header: string;
  subText?: string;
  isVisible: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  IconComponent?: any;
  children?: React.ReactNode;
  buttonText?: string;
};

const ConfirmationModal = ({
  header,
  subText = " ",
  isVisible,
  handleClose,
  onConfirm,
  IconComponent,
  children,
  buttonText,
}: ConfirmationModalProps) => {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: 3,
    pt: 1,
    pb: 4,
    pl: 2,
    pr: 2,
    width: 400,
    textAlign: "center",
  };

  return (
    <Modal
      open={isVisible}
      onClose={handleClose}
      aria-labelledby="confirmation-modal-title"
      aria-describedby="confirmation-modal-description"
    >
      <Box sx={style}>
        <Box display="flex" justifyContent="flex-end">
          <Button
            style={{ minWidth: "32px" }}
            onClick={handleClose}
            sx={{
              border: "1px solid #ccc",
              borderRadius: "50%",
              height: 32,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <i className="fa-solid fa-xmark" style={{ fontSize: 20 }}></i>
          </Button>
        </Box>

        {/* <WarningAmberIcon color="error" sx={{ fontSize: 40, mb: 1 }} /> */}
        <Typography color="error" sx={{ fontSize: 40, mb: 1 }}>
          {IconComponent}
        </Typography>

        <Typography variant="h6" fontWeight="bold" gutterBottom>
          {header}
        </Typography>

        <Typography variant="body2" color="text.secondary" mb={3}>
          {subText}
        </Typography>
        <Typography variant="body2" color="text.secondary" mb={3}>
          {children}
        </Typography>

        <Box display="flex" gap={2} justifyContent="center">
          <Button
            variant="outlined"
            onClick={handleClose}
            sx={{
              borderRadius: 2,
              minWidth: 140,
              borderColor: "#d5ad27",
              color: "#d5ad27",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            onClick={onConfirm}
            sx={{ borderRadius: 2, minWidth: 140, backgroundColor: "#211813" }}
          >
            {!!buttonText ? buttonText : "Submit"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
